import { ArrowDownIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { useFlags } from "@/utils/flagsmith/useFlags";

interface JumpToSectionProps {
    targetSection: string;
    label: string;
}

export function JumpToSection({ targetSection, label }: JumpToSectionProps) {
    const flags = useFlags();
    const showDataSources = flags.enabled("show-coming-soon-placeholders");

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        const element = document.getElementById(targetSection);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    if (!showDataSources) {
        return null;
    }

    return (
        <a
            href={`#${targetSection}`}
            onClick={handleClick}
            className={clsx(
                "text-link flex items-center gap-2",
                "transition-colors duration-200",
                "my-6 sm:mb-10",
                "group",
            )}
        >
            {label}
            <ArrowDownIcon
                className={clsx(
                    "size-4 transition-all duration-300 ease-out",
                    "group-hover:translate-y-1 group-hover:stroke-brand-400",
                )}
            />
        </a>
    );
}
